import {parseNumber, twMerge} from '@sdox/utils'

import {AnimatedCount} from '../../'

import type {KpiItemBaseProps} from './Kpi.Item'
import type {ReactNode} from 'react'

const Value = ({value, variant}: Pick<KpiItemBaseProps, 'value' | 'variant'>) => {
  let content: ReactNode = value
  if (typeof value === 'number' && typeof variant === 'string') {
    content = (
      <AnimatedCount
        value={value}
        direction={variant}
        transformFn={parseNumber}
      />
    )
  }

  return (
    <label className={'line-clamp-1 text-d1-xs text-glyph-default-primary @[600px]:text-cqw @[880px]:text-d1'}>
      {content}
    </label>
  )
}
const Unit = ({unit}: Pick<KpiItemBaseProps, 'unit'>) => (
  <label className={'line-clamp-1 text-p1 text-glyph-default-primary'}>
    {unit}
  </label>
)

const Label = ({title}: Pick<KpiItemBaseProps, 'title'>) => (
  <label className={'line-clamp-2 text-p1 text-glyph-default-primary'}>
    {title}
  </label>
)

const Description = ({subtitle}: Pick<KpiItemBaseProps, 'subtitle'>) => (
  <label className={'mt-spacing-2 line-clamp-8 max-w-text text-p2 text-glyph-default-secondary'}>
    {subtitle}
  </label>
)

/**
 * KpiItem component
 * shows information with a large text value with unit side by side.
 * the title and subtitle are rather smaller, positioned at the bottom.
 */
export const KpiItemDefault = ({title = '', value, unit, subtitle = '', className, variant, ...restProps}: KpiItemBaseProps) => (
  // since we use subgrid, we don't have to check if any of title, value, unit or subtitle are empty
  <div
    className={twMerge(
      'row-span-3 grid grid-rows-subgrid gap-spacing-8',
      className,
    )}
    {...restProps}
  >
    {<Label title={title} />}
    <div className={'flex items-baseline gap-spacing-4'}>
      <Value
        value={value}
        variant={variant}
      />
      <Unit unit={unit}/>
    </div>
    {subtitle && <Description subtitle={subtitle}/>}
  </div>
)
